// extracted by mini-css-extract-plugin
export default {"chart":"BarsChart_chart__ff9Ki"};